import { createAction, props } from '@ngrx/store';
import { ILinkedBusinessesRequest } from '../models/linked-businesses.model';

export const loadBusinessViewLinkedAssetManagers = createAction(
  '[BusinessViewLinkedAssetManager] Load BusinessViewLinkedAssetManagers',
  props<{ request: ILinkedBusinessesRequest }>()
);

export const loadBusinessViewLinkedAssetManagersSuccess = createAction(
  '[BusinessViewLinkedAssetManager] Load BusinessViewLinkedAssetManagers Success',
  props<{ response: any }>()
);

export const loadBusinessViewLinkedAssetManagersFailure = createAction(
  '[BusinessViewLinkedAssetManager] Load BusinessViewLinkedAssetManagers Failure',
  props<{ error: Error | any }>()
);

export const clearBusinessViewLinkedAssetManagers = createAction(
  '[Clear BusinessViewLinkedAssetManager] Clear BusinessViewLinkedAssetManagers'
);
